import ConfirmationDialog from "components/common/ConfirmationDialog";

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
}

export default function CancelScheduledChangeConfirmation(props: Props) {
  const content = "You are about to cancel your subscription change";

  return (
    <ConfirmationDialog
      content={content}
      onCancel={props.onCancel}
      onConfirm={props.onConfirm}
      title="Cancel subscription change"
      cancelButtonText="Back"
      confirmButtonText="CONFIRM"
    />
  );
}
